"use client";
import { cn as e } from "../../../utils/utils.mjs";
import { SelectRoot as t, SelectTrigger as n, SelectValue as r } from "../../atoms/Select/Select.mjs";
import { jsx as i, jsxs as a } from "react/jsx-runtime";
//#region src/components/molecules/SelectInput/SelectInput.tsx
var o = ({ className: o, children: s, iconPrefix: c, iconSuffix: l, placeholder: u, selectTriggerProps: d, selectValueProps: f, ...p }) => /* @__PURE__ */ a(t, {
	...p,
	children: [/* @__PURE__ */ i(n, {
		iconPrefix: c,
		iconSuffix: l,
		className: e("min-w-38 p-4 rounded-sm dark:bg-neutral-dark-200 dark:hover:not-disabled:bg-neutral-dark-400 dark:text-neutral-dark-1000 disabled:dark:text-neutral-dark-600", o),
		...d,
		children: /* @__PURE__ */ i(r, {
			placeholder: u,
			...f
		})
	}), s]
});
//#endregion
export { o as SelectInput };
